<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title moduleIdentifier="magalu" :title="$t('magalu.account.label')">
        <div class="btnGroup" slot="header-right">
          <button @click="changeStatus(false)" v-bind:class="{ 'is-active': !magaluAccount.active }" class="btn btn--info btn--outline">
            Inativo
          </button>
          <button @click="changeStatus(true)" v-bind:class="{ 'is-active': magaluAccount.active }" class="btn btn--info btn--outline">
            Ativo
          </button>
        </div>
      </page-title>
      <div class="l-row vertical-flex">
        <div class="l-col-3@md img-account">
          <img v-if="magaluAccount.logo" :src="magaluAccount.logo"/>
          <i v-if="!magaluAccount.logo" class="icon-image2 no-photo"/>
        </div>
        <div class="l-col-9@md">
          <panel title="Dados da conta">
            <span class="ds-block"><strong>Identificador inteno:</strong> {{ magaluAccount.identifier }}</span>
          </panel>
        </div>
      </div>
      <div class="l-row">
        <div class="l-col-12@md">
          <panel title="Autenticação">
            <div slot="header-right">
              <button class="hint hint--left btn" @click="refreshToken" data-label="Renovar token"><i class="icon-sync icon-loop2"></i></button>
            </div>
            <span class="ds-block"><strong>Token de acesso:</strong> {{ magaluAccount.accessToken }}</span>
            <span class="ds-block"><strong>Token de renovação:</strong> {{ magaluAccount.refreshToken }}</span>
            <span class="ds-block"><strong>Data de expiração:</strong> {{ magaluAccount.expirationDate.replace('.000Z', '') | moment('DD/MM/YYYY HH:mm') }}</span>
          </panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'
  import ModuleLogo from '@/components/template/ModuleLogo'
  import notifier from '@/notifier'
  import api from '@/api'
  import Panel from '@/components/template/Panel'
  import cookie from 'vue-cookie'

  export default {
    props: {
      identifier: {
        type: String,
        required: false
      }
    },
    data: () => ({
      magaluAccount: {},
      loading: true,
      nickname: cookie.get('merchant')
    }),
    async mounted () {
      if (!this.account) {
        await this.fetchAccounts({})
      }

      this.loading = false
    },
    methods: {
      ...mapActions('magaluAccounts', [
        'fetchAccounts',
        'setAccount'
      ]),
      isActive () {
        return {
          'success': this.magaluAccount.active,
          'error': !this.magaluAccount.active
        }
      },
      getStatusLabel (status) {
        if (status) {
          return 'magalu.accounts.active.label'
        }
        return 'magalu.accounts.inactive.label'
      },
      editAction () {
        return this.$router.push(`/` + this.magaluAccount.identifier)
      },
      async refreshToken () {
        this.loading = true

        try {
          const refreshedAccount = (await api.magalu.refreshTokenManually(this.magaluAccount.identifier))

          this.magaluAccount = refreshedAccount

          this.setAccount(refreshedAccount)

          this.loading = false

          notifier.success(`Token da conta renovado com sucesso.`, 'Sucesso')
        } catch (error) {
          this.loading = false

          notifier.error('Erro na renovação do token da conta.', 'Erro')
        }
      },
      async changeStatus (status) {
        this.loading = true

        if (this.magaluAccount.active === status) {
          this.loading = false

          return false
        }

        try {
          await api.magalu.updateAccountStatus(this.magaluAccount.identifier, status)

          this.magaluAccount.active = status

          this.loading = false

          notifier.success(`Status da conta alterado com sucesso.`, 'Sucesso')
        } catch (error) {
          this.loading = false

          notifier.error('Erro na alteração de status da conta.', 'Erro')
        }
      }
    },
    computed: {
      ...mapGetters('magaluAccounts', [
        'getAccount'
      ]),
      async account () {
        this.magaluAccount = await api.magalu.getAccountByIdentifier(this.identifier)
        return this.magaluAccount
      }
    },
    components: {
      Loader,
      PageTitle,
      ModuleLogo,
      Panel
    }
  }
</script>

<style lang="sass" scoped>
  .img-account
    text-align: center
    padding: 30px 0

    img
      max-height: 100%
      margin: 5px 0 16px
      max-width: 150px

    .no-photo
      font-size: 150px
      color: darkgrey
</style>



// WEBPACK FOOTER //
// Edit.vue?514d4378